mutation updatePhonecallShouldSummarize($input: PhoneCallSetShouldSummarizeInput!) {
    phonecallSetShouldSummarize(input: $input) {
        wasUpdated
    }
}
